export default __webpack_public_path__ + "static/media/pending-empty-background.9ff30763.png";